import { signOut } from "../api/auth";
import logger from "./logger";
import { markSignedOut } from "./returnTo";

export async function logout(
  userId: string,
  clearAuth: () => void,
): Promise<void> {
  // An explicit sign-out drops any link waiting for the next sign-in.
  markSignedOut();
  // Spec 2026-10-27: IAM signs the session out and publishes the event that stops this account's pushes in
  // pusher-stc. Fired once, never waited for, never retried; the session cookies go with it. The FCM token
  // itself is NOT deleted: Firebase console campaigns still reach this browser.
  void signOut().catch((e) => logger.warn("[logout] IAM sign-out failed", e));
  if (userId) {
    // The next sign-in (same or another account) must register again.
    localStorage.removeItem(`fcm_token_${userId}`);
  }

  clearAuth();
}
